import { useStores } from "@/stores/useStores";

/** Access the root PM store (disciplines + sub-stores) */
export function usePMStore() {
  return useStores().pmStore;
}

/** Access the issues sub-store */
export function useIssuesStore() {
  return useStores().pmStore.issues;
}

/** Access the mentions sub-store (WHA-3339 unread-mention dots) */
export function useMentionsStore() {
  return useStores().pmStore.mentions;
}

/** Access the notifications sub-store (WHA-3733 unread-activity dot) */
export function useNotificationsStore() {
  return useStores().pmStore.notifications;
}

/**
 * WHA-3507: access the per-project members cache that powers project-scoped
 * issue assignee pickers and @-mention suggestions.
 */
export function useProjectMembersStore() {
  return useStores().pmStore.projectMembers;
}
